import type { LucideIcon } from 'lucide-react'
import {
  BarChart3,
  BookOpen,
  LayoutDashboard,
  ListChecks,
  Megaphone,
  MessageSquare,
  Phone,
  Radio,
  Settings,
  ShieldCheck,
  Users,
} from 'lucide-react'
import { APP_PATHS } from '../router/routes'

export interface SidebarItemConfig {
  to: string
  icon: LucideIcon
  label: string
  subtitle?: string
  end?: boolean
  isActive?: (pathname: string) => boolean
  badge?: 'pendingTasks'
}

export interface BusinessSectionConfig {
  title: string
  items: SidebarItemConfig[]
}

export const individualTopItems: SidebarItemConfig[] = [
  { to: APP_PATHS.root, icon: MessageSquare, label: 'Home', end: true },
  { to: APP_PATHS.line, icon: Phone, label: 'My Calls', subtitle: 'Calls, recordings & tasks', badge: 'pendingTasks' },
]

export const individualBottomItems: SidebarItemConfig[] = [
  {
    to: APP_PATHS.settings,
    icon: Settings,
    label: 'Settings',
    isActive: (p) => p.startsWith(APP_PATHS.settings) && p !== APP_PATHS.briefing,
  },
]

export const businessSections: BusinessSectionConfig[] = [
  {
    title: 'Inbound',
    items: [
      { to: APP_PATHS.root, icon: LayoutDashboard, label: 'Dashboard', end: true },
      { to: APP_PATHS.knowledge, icon: BookOpen, label: 'AI Knowledge' },
      { to: APP_PATHS.routing, icon: Phone, label: 'Call Routing' },
      { to: APP_PATHS.monitor, icon: Radio, label: 'Live Monitor' },
    ],
  },
  {
    title: 'Outbound',
    items: [
      { to: APP_PATHS.campaigns, icon: Megaphone, label: 'Campaigns' },
      { to: APP_PATHS.contacts, icon: ListChecks, label: 'Contact Lists' },
      { to: APP_PATHS.outboundPerformance, icon: BarChart3, label: 'Performance' },
    ],
  },
  {
    title: 'Manage',
    items: [
      { to: APP_PATHS.compliance, icon: ShieldCheck, label: 'Compliance' },
      { to: APP_PATHS.accounts, icon: Users, label: 'Accounts' },
      { to: APP_PATHS.settings, icon: Settings, label: 'Settings' },
    ],
  },
]
